export const SET_IS_SHOW_TRANSPORT_DETAIL = 'SET_IS_SHOW_TRANSPORT_DETAIL';
